<div class="student-info">
    <p class="student-name">{{student.fullName}}</p>
    <p class="group-name">{{student.group.name}}</p>
    <div class="phone-container">
        <mat-icon>school</mat-icon>
        <p>{{student.schoolName}}</p>
    </div>
    <div class="phone-container">
        <mat-icon>account_circle</mat-icon>
        <phone-number [number]="student.phoneNumber"></phone-number>
    </div>
    <div class="phone-container">
        <mat-icon>escalator_warning</mat-icon>
        <phone-number [number]="student.parentPhoneNumber"></phone-number>
    </div>
    <div class="vertical-center phone-container">
        <mat-icon>email</mat-icon>
        <p>{{student.email}}</p>
    </div>
    <div class="vertical-center phone-container" *ngIf="student.isSuspended">
        <mat-icon>block</mat-icon>
        <p>{{student.suspensionNote}}</p>
    </div>
    
    <!-- Devices Section -->
    <div class="devices-section" *ngIf="student.devices && student.devices.length > 0">
        <div class="devices-header">
            <mat-icon>devices</mat-icon>
            <p class="devices-title">Devices ({{student.devices.length}})</p>
        </div>
        <div class="device-item" *ngFor="let device of student.devices; let i = index">
            <div class="device-info">
                <div class="device-main">
                    <mat-icon class="device-icon">{{getDeviceIcon(device.type)}}</mat-icon>
                    <div class="device-details">
                        <p class="device-name">{{device.browserName}} {{device.browserVersion}}</p>
                        <p class="device-os">{{device.os}} {{device.osVersion}}</p>
                        <p class="device-model" *ngIf="device.model && device.model !== 'undefined'">{{device.vendor}} {{device.model}}</p>
                    </div>
                </div>
                <div class="device-meta">
                    <p class="device-ip" *ngIf="device.ipAddress">IP: {{device.ipAddress}}</p>
                    <p class="device-id">ID: {{device.eduId}}</p>
                </div>
            </div>
        </div>
    </div>
    
    <div class="no-devices" *ngIf="!student.devices || student.devices.length === 0">
        <div class="vertical-center phone-container">
            <mat-icon>devices_other</mat-icon>
            <p>No registered devices</p>
        </div>
    </div>
</div>